export enum TYPES_BLOCK {
    left = 'left',
    right = 'right'
}
